/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import { setDataCounter } from "./setDataCounter";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/**
 * 初期値
 */
let html = document.documentElement;

/**
 * 処理
 */
const setSplash = () => {
  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      if (window.document.body.classList.contains("home")) {
        loadingAnimation("home");
        setTimeout(() => { setDataCounter() }, 2000);
      } else {
        loadingAnimation("lower");
      }
      hintBrowser();
    }, 2000);

  });
};

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __20:対象のクラスを削除
 */
function hintBrowser() {
  let willChangeItem = document.querySelectorAll(".--hintBrowser");
  for (let i = 0; i < willChangeItem.length; i++) {
    willChangeItem[i].classList.remove("--hintBrowser");
  }
}

/**
 * __30:ローディングアニメーション - 共通処理
 */
function loadingAnimation(type) {
  let splash = document.querySelector(".splash");
  let splashItem__first = document.querySelector(".--item__first");
  let splashItem__second = document.querySelector(".--item__second");
  let splashItem__logo = document.querySelector(".--item__logo");
  let splashItem__logo_parts01 = document.querySelector(".--item__logo-parts01");
  let splashItem__logo_parts02 = document.querySelectorAll(".--item__logo-parts02 > path");
  let tl = gsap.timeline();

  const complete = () => {
    html.classList.remove("--loading");
    splash.remove();
  }

  // ローディングアニメーション - TOPページ
  const home = () => {
    let copy = document.querySelectorAll(".mv .copy .text-line > span");
    tl.to([splashItem__logo_parts01], { duration: 1, opacity: 1, ease: "Quart.easeOut", })
      .to([splashItem__logo_parts02], { duration: 0.75, y: 0, ease: "Quart.easeOut", stagger: 0.1, }, "<")
      .to([splashItem__first], { duration: 2, scaleX: 0, ease: "Quart.easeInOut" })
      .to([splashItem__second], { duration: 1.5, scaleX: 0, ease: "Quart.easeOut" }, "<1")
      .to([splashItem__logo], { duration: 1, scale: 1.1, opacity: 0, ease: "Quart.easeOut" }, "<")
      .to([copy], { duration: 1.5, y: 0, rotateZ: 0, ease: "Quart.easeInOut", stagger: 0.1, onComplete: () => complete() }, "<")
  }

  // ローディングアニメーション - 下層ページ
  const lower = () => {
    let title = document.querySelectorAll(".content__title h1 .--js_createSpan > span");
    let subTitle = document.querySelectorAll(".content__title p > span");
    let img = document.querySelectorAll(".content__title__mv .img");
    let alpha = document.querySelectorAll(".--alpha");
    tl.to([splashItem__first], { duration: 2, scaleX: 0, ease: "Quart.easeInOut" })
      .to([splashItem__second], { duration: 1.5, scaleX: 0, ease: "Quart.easeOut", }, "<1")
      .to([title], { duration: 1, y: 0, rotateZ: 0, ease: "Quart.easeInOut", stagger: 0.05, }, "<")
      .to([subTitle], { duration: 1, y: 0, rotateZ: 0, ease: "Quart.easeInOut", stagger: 0.05, }, "<")
      .to([img, alpha], { duration: 1, scale: 1, opacity: 1, ease: "Quart.easeInOut" }, "<")
      .to([html], { onComplete: () => complete() })
  }

  type === "home" ? home() : lower();
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  setSplash
};